import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SettingList from './SettingList.jsx';
import AudienceForm from '../../containers/boardSetup/components/Audiences/AudienceForm.jsx';
import {
  fetchPopulationSegments,
  deleteAudience,
} from '../../lib/redux/actions.jsx';
import DeleteModal from './DeleteModal.jsx';
import AudiencesModal from './AudiencesModal.jsx';

const TopicsList = () => {
  const { t } = useTranslation(['edit']);
  const audiences = useSelector(state => state.status.audiences);
  const dispatch = useDispatch();
  const deleteTexts = [t('edit:audiencesList:deleteTopicPhrase1')];

  useEffect(() => {
    dispatch(fetchPopulationSegments());
  }, [dispatch]);

  const onDelete = item => {
    return DeleteModal({
      phrases: deleteTexts,
      onCancel: () => AudiencesModal(),
      onConfirm: () => {
        dispatch(deleteAudience(item));
        AudiencesModal();
      },
    });
  };

  return (
    <SettingList
      collection={audiences}
      settingName={t('edit:audiencesList:settingName')}
      form={AudienceForm}
      onDelete={onDelete}
    />
  );
};

export default TopicsList;
